export const defaultDeviceProfileWidgets = [
	{
		enabled: true,
		id: "access_control",
		index: 0
	},
	{
		enabled: true,
		id: "files",
		index: 1
	},
	{
		enabled: true,
		id: "activities",
		index: 2
	},
	{
		enabled: true,
		id: "cameras",
		index: 3
	},
	{
		enabled: true,
		id: "map",
		index: 4
	},
	{
		enabled: true,
		id: "details",
		index: 5
	},
	{
		enabled: true,
		id: "cameraClusters",
		index: 6
	},
	{
		enabled: true,
		id: "alerting_zones",
		index: 7
	}
];
